export default "__VITE_ASSET__CxGkH7Ga__"